<template>
    <button :class="[disabled ? 'disabled_button' : 'simple_button']"
        :style="computedStyle"
        @click="onButtonClick()">
        <slot></slot>
    </button>
</template>
<script>
export default {
    name: "SimpleButton",
    data() {
        return {
        };
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        buttonStyle: {
            type: String,
            default: '',
        }
    },
    computed: {
        computedStyle() {
            return !this.disabled ? { backgroundImage: this.buttonStyle } : {};
        }
    },
    methods: {
        onButtonClick() {
            if (this.disabled) {
                return;
            }
            this.$emit('click');
        },
    },
};
</script>
<style scoped>
.disabled_button {
    background-color: #eee;
    padding: 0.01em 1em 0.01em 0.7em;
    margin: 1px 0 1px 0;
    border: none;
    border-radius: 1px;
    font-weight: bold;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
}
.disabled_button:hover {
    background-color: #eee;
}
.simple_button {
    cursor: pointer;
    padding: 0.01em 1em 0.01em 0.7em;
    margin: 1px 0 1px 0;
    border: 1px solid #c0c0ff38;
    border-radius: 1px;
    font-weight: bold;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
    transition: background-color 0.07s, transform 0.07s, filter 0.07s;
}
.simple_button:hover:after{ 
    content:''; 
    position: fixed;
    top: 0; bottom: 0; left: 0; right: 0; 
    background:rgba(255,255,255,.2);
}
.simple_button:hover {
    background-color: #ffffff90;
    transform: translateY(-2px);
    filter: drop-shadow(-2px 2px 4px #d0d0d0ff);
}
.simple_button:active {
    background-color: #ccf;
    transform: translateY(1px);
}
</style>